import {AbstractModel} from './abstract-model';
import {Partner} from './partner';
import {Offer} from './offer';

export class PartnerOffer extends AbstractModel {
  id: number | null = null;
  partner: Partner | null = null;
  status: string = 'pending';
  subid: string | null = null;
  offer: Offer | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    return this;
  }
}
